import { useMutation, useQueryClient } from "@tanstack/react-query";
import distributorTypeApi from "../services/distributorType.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DISTRIBUTOR_TYPE_MESSAGES_ERROR,
  DISTRIBUTOR_TYPE_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableDistributorType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => distributorTypeApi.enable(id),
    onError: () => {
      errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.ENABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(DISTRIBUTOR_TYPE_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["distributor-types"] });
    },
  });
};

export const useDisableDistributorType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => distributorTypeApi.disable(id),
    onError: () => {
      errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.DISABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(DISTRIBUTOR_TYPE_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["distributor-types"] });
    },
  });
};
